import axios from "axios";
import {ORDER_API} from "../constants/apiUrls";
// import {getUserInfo, orderApiUrl} from "utils/CommonUtils";

// 년도별 통계 조회 API
export const getYearlyStatisticsApi = async (data) => {
  const response = await axios.get(`${ORDER_API}/statistics/ceo/yearly`, {
    params: data,
    headers: {Authorization: `Bearer ceo`}
  });

  return response.data;
};

// 월별 통계 조회 API
export const getMonthlyStatisticsApi = async (data) => {
  const response = await axios.get(`${ORDER_API}/statistics/ceo/monthly`, {
    params: data,
    headers: {Authorization: `Bearer ceo`}
  });

  return response.data;
};

// 일별 통계 조회 API
export const getDailyStatisticsApi = async (data) => {
  const response = await axios.get(`${ORDER_API}/statistics/ceo/daily`, {
    params: data,
    headers: {Authorization: `Bearer ceo`}
  });

  return response.data;
};




/**
 * 이하 함수는 서버 대상 식별 불가
 * 함수 내부 주석처리
 * 
 * @date 2026-04-17
 * @author Saccharin01
 */

// new 년도별 통계 조회 api
export const getNewYearlyStatisticsApi = async (data) => {
  // const {accessToken} = getUserInfo();

  // const response = await axios.get(`${ORDER_API}/ceo/statistics/yearly`, {
  //   params: data,
  //   headers: {Authorization: `Bearer ${accessToken}`,}
  // });

  // return response.data;
};


// new 월별 통계 조회 api
export const getNewMonthlyStatisticsApi = async (data) => {
  // const {accessToken} = getUserInfo();

  // const response = await axios.get(`${newTestApiUrl}/ceo/statistics/monthly`, {
  //   params: data,
  //   headers: {Authorization: `Bearer ${accessToken}`,}
  // });

  // return response.data;
};


// new 년도별 통계 조회 api
export const getNewDailyStatisticsApi = async (data) => {
  // const {accessToken} = getUserInfo();

  // const response = await axios.get(`${newTestApiUrl}/ceo/statistics/daily`, {
  //   params: data,
  //   headers: {Authorization: `Bearer ${accessToken}`,}
  // });

  // return response.data;
};

